import Serializer from 'umg-ember-backend/serializers/application';

export default class LiveEventSerializer extends Serializer {
  attrs = {
    type: 'categoryId',
    ownedByChannel: 'ownedByChannelId',
  };
}
